import { useEffect, useState } from "react";
import { PageHero } from "./MarketingLayout";
import { endpoints } from "@/lib/api";
import { X } from "lucide-react";

export default function Gallery() {
  const [imgs, setImgs] = useState([]);
  const [active, setActive] = useState(null);
  useEffect(() => { endpoints.gallery().then(setImgs).catch(() => {}); }, []);
  return (
    <div>
      <PageHero eyebrow="From the floor" title="Gallery"
        subtitle="A look at the builds, the crowd and the neon soaked atmosphere of Perth Auto Salon." />
      <section className="max-w-7xl mx-auto px-6 pb-24">
        <div className="columns-2 md:columns-3 gap-4 space-y-4">
          {imgs.map((im, i) => (
            <button key={im.id} onClick={() => setActive(im.url)} data-testid={`gallery-${i}`}
              className="block w-full overflow-hidden border border-white/10 group">
              <img src={im.url} alt={im.caption} className="w-full group-hover:scale-105 transition-transform duration-500" />
            </button>
          ))}
        </div>
      </section>
      {active && (
        <div className="fixed inset-0 z-[60] bg-black/90 grid place-items-center p-6" onClick={() => setActive(null)} data-testid="lightbox">
          <button className="absolute top-6 right-6 text-white"><X size={28} /></button>
          <img src={active} alt="" className="max-h-[85vh] max-w-full border border-white/10" />
        </div>
      )}
    </div>
  );
}
